<template>

    <div v-if="project">

        <div class="project-name">
            {{ project.name }}
        </div>

        <div class="project-tracks-count text-stardust-grey">
            {{ tracks.length }} Tracks.
        </div>

        <div class="form-group">
            <label for="projectEmailInput">
                Tracks:
            </label>
            <table class="table">
                <thead>
                <th>
                    Title / Track No.
                </th>
                <th>
                    Composer / Album
                </th>
                <th width="150px">
                    Duration
                </th>
                <th width="250px">
                    Notes
                </th>
                </thead>
                <tbody>
                <email-cue-sheet-row v-for="(track, index) in tracks" v-bind:key="index" :track="track" :trackDurationProp="trackDuration[track.id]" :trackDurationParsedProp="trackDurationParsed[track.id]" :trackNotesProp="trackNotes[track.id]" v-on:trackDuration="v => trackDuration[track.id] = v" v-on:trackDurationParsed="v => trackDurationParsed[track.id] = v" v-on:trackNotes="v => trackNotes[track.id] = v" />
                </tbody>
            </table>
        </div>

        <div class="form-group">

            <label for="projectEmailInput">
                Email Recipient:
            </label>

            <input type="email" class="form-control" id="projectEmailInput" placeholder="me@example.com" v-model.lazy="email" required />
            <p v-if="emailError" class="text-danger"> A valid recipient's email is required  </p>

        </div>

        <div class="form-group">

            <label for="userEmailInput">
                Your Email:
            </label>

            <input type="email" class="form-control" id="userEmailInput" placeholder="me@example.com" v-model.lazy="useremail" required/>
            <p v-if="emailError" class="text-danger"> A valid sender's email is required  </p>


        </div>

        <a class="btn btn-raised btn-danger btn-xl font-weight-semibold" href="#" v-on:click.prevent="saveCueSheet">
            Save
        </a>

        <a class="btn btn-raised btn-danger btn-xl font-weight-semibold" href="#" v-on:click.prevent="emailCueSheet">
            Share
        </a>

        <a class="btn btn-raised btn-danger btn-xl font-weight-semibold" href="#" v-on:click.prevent="downloadCueSheet">
            Download
        </a>

        <span style="display: none">{{ changeTimestamp }}</span>

    </div>

</template>

<script>

    import Vue from 'vue';
    import ToastrType from '../toastr-types.interface';
    import {playerService} from '../player-service';
    import EmailCueSheetRow from './email-cue-sheet-row';

    export default Vue.component(
        'email-cue-sheet',
        {

            data: function () {

                return {

                    changeTimestamp: new Date(),
                    project: null,
                    notes: null,
                    email: null,
                    useremail: typeof window.authenticatedUserEmail === "undefined"?null:window.authenticatedUserEmail,
                    trackDuration: {},
                    trackDurationParsed: {},
                    trackNotes: {},
                    tracks: [],
                    emailError: false

                };

            },

            mounted: function () {

                playerService.$on( 'user-updated', () => {
                    this.useremail = typeof window.authenticatedUserEmail === "undefined"?null:window.authenticatedUserEmail;
                } );

                // Change the edit project contents depending on whats passed to it.
                playerService.$on(
                    'email-cue-sheet',
                    (project) => {

                        // Update curr track for modal.
                        this.project = project;

                        // Open the modal.
                        window.webpackOpenBsModalWorkaround('#emailCueSheetModal');

                    }
                );

            },

            methods: {

                /**
                 * Loads the up to date tracks for the cuesheet.
                 */
                loadTracks: function() {

                    let ctx = this;

                    $.ajax({
                        method: 'GET',
                        url: '/api/projects/' + this.project.id + '/tracks',
                        data: {
                            'disablepagination': true
                        },
                        cache: false
                    })
                    .done(function( response ) {

                        if( typeof response.data !== 'undefined' ) {

                            ctx.tracks = response.data;

                        } else {

                            if(window.adminProjectShare == true) {
                                playerService.toast(`[PLYR_151228] Error: Track Resource response was obtained but invalidated data schema was provided.`, ToastrType.Error);
                            }
                        }

                    })
                    .fail(function( responseData ) {

                        if(window.adminProjectShare == true) {
                            playerService.toast(`[PLYR_151229] Error: Could not load Tracks for Email Cue Sheet.`, ToastrType.Error);
                        }
                    })
                    .always(function( responseData ) {

                        ctx.tracklistLoader = false;

                    });

                },

                emailCueSheet: function () {

                    if(this.email === null || !(this.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))|| !(this.useremail.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))){
                        this.emailError = true;
                        return false;
                    }

                    this.emailError = false;

                    playerService.emailCueSheet(this.project, this.email, this.useremail, this.trackNotes, this.trackDurationParsed);

                },

                downloadCueSheet: function () {

                    playerService.downloadCueSheet( this.project, this.trackNotes, this.trackDurationParsed );

                },

                saveCueSheet: function () {

                    playerService.saveCueSheet(this.project, this.trackNotes, this.trackDuration);

                    let cuesheet = [];

                    for( let index = 0; index < this.tracks.length; index++ ) {

                        let track = this.tracks[ index ];

                        cuesheet.push({
                            "id": track.id,
                            "title": track.title,
                            "composer": track.composer,
                            "album_code": track.album_code,
                            "duration": this.trackDuration[ track.id ],
                            "notes": ( typeof this.trackNotes[ track.id ] != 'undefined' ? this.trackNotes[ track.id ] : '' )
                        });

                    }

                    this.project.cue_sheet = cuesheet;

                },

                reset: function () {

                    this.email = null;
                    this.trackDuration = {};
                    this.trackDurationParsed = {};
                    this.trackNotes = {};
                    this.tracks = [];

                    // Read the track notes + duration from the project.
                    if( typeof this.project.cue_sheet != 'undefined'  && this.project.cue_sheet != null ) {

                        let cue_sheet = this.project.cue_sheet;

                        if( typeof this.project.cue_sheet == 'string' ) {
                            cue_sheet = JSON.parse( cue_sheet );
                        }

                        for( let index = 0; index < cue_sheet.length; index++ ) {

                            let track = cue_sheet[ index ];

                            this.trackNotes[ track.id ] = track.notes;
                            this.trackDuration[ track.id ] = track.duration;
                            this.trackDurationParsed[ track.id ] = this.parseDuration( track.duration );

                        }

                    }

                    this.changeTimestamp = new Date();

                },

                parseDuration: function( rawDuration ) {

                    rawDuration = parseInt(rawDuration, 10).toString();

                    if( isNaN( rawDuration ) ) {
                        return;
                    }

                    let len = rawDuration.length;

                    var parsedDuration = null;

                    if(len == 2){
                        parsedDuration = rawDuration.substring(0, len-2) + "00:" + rawDuration.substring(len-2);
                    }
                    if(len == 1){
                        parsedDuration = rawDuration.substring(0, len-2) + "00:0" + rawDuration.substring(len-2);
                    }
                    if(len == 3){
                        parsedDuration = '0'+ rawDuration.substring(0, len-2) + ":" + rawDuration.substring(len-2);
                    }
                    if(len > 3){
                        parsedDuration = rawDuration.substring(0, len-2) + ":" + rawDuration.substring(len-2);
                    }

                    return parsedDuration;

                }

            },

            watch: {
                project: function (value) {

                    this.reset();
                    this.loadTracks();

                },

            },

            components: {
                EmailCueSheetRow
            }

        }
    );

</script>

<style>
    .duration-input.duration-input--raw {
        height: 0;
        overflow: hidden;
        width: 0;
        margin: 0;
        padding: 0;
        border: none;
    }

    .duration-input.duration-input--raw:focus + .duration-input--parsed {
        border-color: #9acffa;
    }

</style>
